export default __webpack_public_path__ + "static/media/SobreWinvest.c389fe70.png";